import * as routes from "./routes"
export const LOGIN = `/${routes.LOGIN}`;
export const DASHBOARD = `/${routes.DASHBOARD}`
export const USER = `/${routes.USER}`
export const AttendaceReport = `/${routes.REPORTS}/${routes.ATTENDANCE}`

export const DOCUMENT_ROUTES = `/${routes.DOCUMENT_MASTER}`
